import { Country } from '@afterpaytouch/portal-api/types'
import { CheckoutMerchantDetails, validateLocale } from '../../model'

export interface CountryRedirectionParams {
  shippingCountryCode?: Country
  billingCountryCode?: Country
  merchant: CheckoutMerchantDetails
  currentCountry: Country
  merchantId: number
  redirectEnabled: boolean
  merchantsWithBillingShippingCountryLanguage: number[]
}

const isSupportedCountry = (merchant: CheckoutMerchantDetails, newCountry: Country): boolean => {
  return merchant.supportedCountries.includes(newCountry)
}

export const determineRedirectCountry = (params: CountryRedirectionParams): Country | undefined => {
  const { shippingCountryCode, billingCountryCode, merchant, currentCountry, merchantId, redirectEnabled, merchantsWithBillingShippingCountryLanguage } = params

  if (!redirectEnabled && !merchantsWithBillingShippingCountryLanguage.includes(merchantId)) {
    return undefined
  }

  const newCountry = billingCountryCode ?? shippingCountryCode

  if (!newCountry) {
    return undefined
  }

  const newLocale = validateLocale('any', newCountry)
  const currentLocale = validateLocale('any', currentCountry)

  if (currentLocale !== newLocale && isSupportedCountry(merchant, newCountry)) {
    return newCountry
  }

  return undefined
}
